import api from './api';

const programService = {
    // Get all programs
    getAllPrograms: async () => {
        const response = await api.get('/programs');
        return response;
    },

    // Get single program by ID
    getProgramById: async (id) => {
        const response = await api.get(`/programs/${id}`);
        return response;
    },

    // Create new program
    createProgram: async (programData) => {
        const response = await api.post('/programs', programData);
        return response;
    },

    // Update program
    updateProgram: async (id, programData) => {
        const response = await api.put(`/programs/${id}`, programData);
        return response;
    },

    // Delete program
    deleteProgram: async (id) => {
        const response = await api.delete(`/programs/${id}`);
        return response;
    }
};

export default programService;
